import moment from "moment";
import { getRoom } from "./build-type-event";

function getAlertType(e) {
  let alert_type = "רגיל";
  if (
    e.alert_type &&
    e.alert_type.alert_type &&
    (e.alert_type.alert_type == "דחוף לרופא" ||
      e.alert_type.alert_type == "בהול")
  ) {
    alert_type = e.alert_type.alert_type;
  }
  return alert_type;
}

/**
 * @param {Object[]} data - are all the events
 * to convert
 *
 * @param {string} apiType - from which api the data
 *
 * @returns {Object[]} Array of objescts
 * the table can read
 */
function getAppointmentEvent(data, apiType = "calendar") {
  if (apiType == "calendar") {
    return data.map(e => {
      return {
        id: e.id ?? e.status.appointment_id ?? "-",
        passport: e.passport ? e.passport : "-",
        patient_phone: e.patient_phone ? e.patient_phone : "-",
        patientName: e.patientName ?? "-",
        date: moment(e.start).format("DD-MM-YYYY"),
        hour: moment(e.start).format("HH:mm"),
        patient_age: e.patient_age ?? e.age.age ?? "-",
        type: e.type ?? "-",
        insurance_name: e.insurance_name ?? "-",
        fee: e.insurance_fee ? `₪${e.insurance_fee}` : "-",
        arrival_status:
          e.arrival_status && e.arrival_status == "y"
            ? "אישר/ה הגעה"
            : "עדיין לא אושר",
        scheduled_by: e.scheduled_by,
        patient_gender: e.patient_gender ?? "-",
        documents_count: e.documents_count ? "הצגת מסמכים" : "-",
        alert_type: getAlertType(e)
      };
    });
  }
  return data.map(e => {
    return {
      id: e.status.appointment_id,
      passport: e.real_patient.passport ?? "-",
      patient_phone: e.phone.phone ?? "-",
      patientName: getFullName(e),
      date: moment(e.date.date).format("DD-MM-YYYY"),
      hour: getHour(e),
      patient_age: e.age.age ?? "-",
      type: e.name.appointment_type ?? "-",
      insurance_name: e.insurance.insurance_name ?? "-",
      fee: e.fee.total_fee ? `₪${e.fee.total_fee}` : "-",
      arrival_status: e.arrival_status.status ?? "-",
      scheduled_by: e.scheduled_by.scheduled_by,
      patient_gender: e.real_patient.gender ?? "-",
      documents_count: e.documents.has_document ? "הצגת מסמכים" : "-",
      alert_type: getAlertType(e)
    };
  });
}

/**
 * @param {Object[]} data - are all the events
 * to convert
 *
 * @param {string} apiType - from which api the data
 *
 * @returns {Object[]} Array of objescts
 * the table can read
 */
function getSurgeryEvent(data, apiType = "calendar") {
  if (apiType == "calendar") {
    return data.map(e => {
      return {
        id: e.id,
        passport: e.passport ?? "-",
        patientName: e.patientName ?? "-",
        patient_phone: e.patient_phone ?? "-",
        date: moment(e.start).format("DD-MM-YYYY"),
        hour: moment(e.start).format("HH:mm"),
        patient_age: e.patient_age ?? "-",
        status_heb: e.status_heb ?? "-",
        insurance_status_heb: e.insurance_status_heb ?? "-",
        insurance_code: e.insurance_code ?? "-",
        insurance_name: e.insurance_name ?? "-",
        insurance_fee: e.insurance_fee ? `₪${e.insurance_fee}` : "-",
        room: getRoom(e.resourceId)?.value.name ?? "-",
        patient_gender: e.patient_gender ?? "-",
        title: e.surgeryName ?? "-",
        documents_count: e.documents_count ? "הצגת מסמכים" : "-",
        alert_type: getAlertType(e)
      };
    });
  }
  return data.map(e => {
    return {
      id: e.status.surgery_id,
      passport: e.real_patient.passport ?? "-",
      patientName: getFullName(e),
      patient_phone: e.phone.phone ?? "-",
      date: moment(e.date.date).format("DD-MM-YYYY"),
      hour: getHour(e),
      patient_age: e.age.age ?? "-",
      status_heb: e.status.status ?? "-",
      insurance_status_heb: e.insurance_status.status_heb ?? "-",
      insurance_code: e.insurance.insurance_code_value
        ? e.insurance.insurance_code_value
        : "-",
      insurance_name: e.insurance.insurance_name
        ? e.insurance.insurance_name
        : "-",
      insurance_fee: e.insurance.insurance_fee_value
        ? `₪${e.insurance.insurance_fee_value}`
        : "-",
      room: e.room.room_number ?? "-",
      patient_gender: e.real_patient.gender,
      title: e.name.surgery_name,
      documents_count: e.documents?.has_document ? "הצגת מסמכים" : "-",
      alert_type: getAlertType(e)
    };
  });
}

/**
 * @param {Object[]} data - are all the events
 * to convert
 *
 * @returns {Object[]} Array of objects
 * the table can read
 */
function getPathologyEvent(data) {
  return data.map(e => {
    let view_count = 0;
    if (e.doctor_view_count && e.doctor_view_count.doctor_view_count) {
      view_count = parseInt(e.doctor_view_count.doctor_view_count);
    }
    let id = "";
    let pathologyType = "";
    if (e.real_patient && e.real_patient.event_name) {
      const splitted = e.real_patient.event_name.split("_");
      if (splitted.length > 1) id = splitted[1];
      pathologyType = splitted[0];
    }
    return {
      created_at: e.created_at
        ? moment(e.created_at.created_at, "DD.MM.YYYY").format("DD-MM-YYYY")
        : "",
      phone: e.phone ? e.phone.phone : "",
      first_name: e.real_patient ? e.real_patient.first_name : "",
      last_name: e.real_patient ? e.real_patient.last_name : "",
      passport: e.real_patient ? e.real_patient.passport : "",
      path: e.file
        ? "https://md-booking.hmc.co.il/ex-doctor/external" + e.file.path
        : "",
      view_count,
      documents_count: e.file && e.file.path ? "פתיחת המסמך" : "-",
      id,
      pathologyType,
      alert_type: getAlertType(e)
    };
  });
}

/**
 * Getting a raw events from getFullCalendarEvents/searchAppointments
 * from the API and converting them to objects
 * the table can read.
 *
 * Use only in case of getting events from
 * calendars.
 *
 * @param {Object[]} data - are all the events
 * to convert
 *
 * @param {string} apiType - from which api the data
 * calendar - getFullCalendarEvents
 * search - searchAppointments
 *
 * @param {string} tableType
 * @returns {Object[]} Array of objects
 * the table can read
 */
export function getTableEvents(
  data,
  tableType = "appointment",
  apiType = "calendar"
) {
  if (tableType == "appointment") {
    return getAppointmentEvent(data, apiType);
  } else if (tableType == "surgery") {
    return getSurgeryEvent(data, apiType);
  } else {
    return getPathologyEvent(data);
  }
}

/**
 * Used only for formatting user name
 * came from search by input. DO NOT use
 * in events came from datepicker.
 *
 * @param {Object} e - event from search
 * @returns {String} full name
 *
 * @example
 * // Expected 'ישראל ישראלי'
 * first_name + ' ' + last_name
 */
function getFullName(e) {
  const name =
    (e.real_patient.first_name ?? "") + " " + (e.real_patient.last_name ?? "");
  if (name.trim() === "") return "-";
  return name;
}

/**
 * Formatting the time from searched event.
 * DO NOT use in events came from datepicker.
 *
 * @param {Object} e - event from search
 * @returns {String} hour to show
 *
 * @example
 * const time = '19:30 - 20:00'
 * return '19:30'
 */
function getHour(e) {
  return e.time.time.split(" - ")[0].trim();
}
